import {styled} from "@mui/material/styles"
import {Select} from "@mui/material"

export const StandardStyledSelectSort = styled(Select)`
    min-width: 13.5rem;
    max-width: 20rem;
    height: 2.25rem;
    &.MuiInputBase-root {
        color: ${({theme}) => theme.colours.form.input.sortPlaceholder};
    }
    &.Mui-focused > :focus-visible {
        outline: ${({theme}) => `0.125rem solid ${theme.colours.palette.info.other.focusRingColor}`};
        outline-offset: 1px;
    }
    & .MuiOutlinedInput-notchedOutline {
        border-color: ${({theme}) => theme.colours.select.borderColor};
    }
    border-radius: ${({theme}) => theme.colours.select.borderRadius};
`
